import React, { useContext, useEffect, useState } from 'react';
import { Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerFooter, IconButton, useTheme } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import { readableColor } from 'polished';
import { GlobalContext } from '@interness/web-core/src/providers/GlobalContext';
import PrimaryNav from './PrimaryNav/PrimaryNav';
import ContactSidebarContent from './ContactSidebarContent';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Sidebar = _ref => {
  let {
    footerDisplay
  } = _ref;
  const {
    0: mounted,
    1: setMounted
  } = useState(false);
  const {
    isSidebarOpen,
    onSidebarClose,
    sidebarContent
  } = useContext(GlobalContext);
  const {
    0: isOpen,
    1: setIsOpen
  } = useState(isSidebarOpen);
  const theme = useTheme();
  useEffect(() => {
    setMounted(true);
    setIsOpen(isSidebarOpen);
  }, [isSidebarOpen]);
  const onClose = () => {
    onSidebarClose();
    setIsOpen(false);
  };
  if (!mounted) {
    return null;
  }
  return ___EmotionJSX(Drawer, {
    isOpen: isOpen,
    placement: 'right',
    onClose: onClose,
    size: 'sm'
  }, ___EmotionJSX(DrawerOverlay, null), ___EmotionJSX(DrawerContent, null, ___EmotionJSX(DrawerCloseButton, {
    sx: {
      color: readableColor(theme.colors.base['500'])
    }
  }), ___EmotionJSX(DrawerHeader, {
    bg: "base.500"
  }, sidebarContent === 'primaryMenu' && ___EmotionJSX(React.Fragment, null, "Men\xFC"), sidebarContent === 'contact' && ___EmotionJSX(React.Fragment, null, "Kontakt")), ___EmotionJSX(DrawerBody, {
    p: 0,
    bgColor: "base.500"
  }, sidebarContent === 'primaryMenu' && ___EmotionJSX(PrimaryNav, null), sidebarContent === 'contact' && ___EmotionJSX(ContactSidebarContent, null)), ___EmotionJSX(DrawerFooter, {
    textAlign: "right",
    borderTopWidth: "1px",
    bg: "base.500",
    display: footerDisplay
  }, ___EmotionJSX(IconButton, {
    colorScheme: "base",
    onClick: onClose,
    "aria-label": "Close",
    icon: ___EmotionJSX(CloseIcon, null)
  }))));
};
export default Sidebar;